import React, { Component } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_badge__1y5yc {\n  width: 60px;\n  height: 60px;\n  right: 1.5rem;\n  bottom: 1.5rem;\n  position: fixed;\n  overflow: hidden;\n  z-index: 2147483646;\n  border-radius: 30px;\n  background: transparent;\n  transition: box-shadow 150ms linear;\n  box-shadow: 0 3px 13px rgba(0, 0, 0, .25);\n}\n\n.styles_badge__1y5yc:hover {\n  box-shadow: 0 5px 25px rgba(0, 0, 0, .5);\n}\n";
var styles = { "badge": "styles_badge__1y5yc" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var WhatsappBadge = function (_Component) {
  inherits(WhatsappBadge, _Component);

  function WhatsappBadge() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, WhatsappBadge);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = WhatsappBadge.__proto__ || Object.getPrototypeOf(WhatsappBadge)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return React.createElement(
        'a',
        { href: 'https://wa.me/' + _this.props.phone + '?text=' + _this.props.text },
        React.createElement('div', { className: styles.badge, style: { backgroundImage: 'url(' + _this.props.image + ')' } })
      );
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return WhatsappBadge;
}(Component);

WhatsappBadge.propTypes = {
  phone: PropTypes.number,
  text: PropTypes.string,
  image: PropTypes.string
};

export default WhatsappBadge;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0